import { render } from "./RecordDetail.vue?vue&type=template&id=1ccf9a76&scoped=true"
import script from "./RecordDetail.vue?vue&type=script&lang=js"
export * from "./RecordDetail.vue?vue&type=script&lang=js"

import "./RecordDetail.vue?vue&type=style&index=0&id=1ccf9a76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccf9a76"]])

export default __exports__